import store from '@/store'
import { Cast } from '../classes'
import { computed, onUnmounted, Ref, watch } from '@vue/composition-api'
import { pickBy } from 'lodash'
import { AssetType } from '@/types/assets'

const useCastScenesAssets = (cast: Ref<Cast|null>, assetTypes?: AssetType[]) => {
  const castAssetIds = computed(() => {
    return cast.value?.getScenesAssetIds(assetTypes) ?? new Set<string>()
  })
  const activeSubscriptionAssetIds = new Set<string>()

  watch(castAssetIds, async (newAssetIds) => {
    const newSubscriptions: Promise<void>[] = []
    newAssetIds.forEach((assetId) => {
      if (activeSubscriptionAssetIds.has(assetId)) return
      newSubscriptions.push(store.dispatch.assets.subscribeAsset(assetId))
      activeSubscriptionAssetIds.add(assetId)
    })
    await Promise.all(newSubscriptions)

    const staleSubscriptions: Promise<void>[] = []
    activeSubscriptionAssetIds.forEach((assetId) => {
      if (newAssetIds.has(assetId)) return
      staleSubscriptions.push(store.dispatch.assets.unsubscribeAsset(assetId))
      activeSubscriptionAssetIds.delete(assetId)
    })
    await Promise.all(staleSubscriptions)
  }, { immediate: true })

  onUnmounted(async () => {
    const staleSubscriptions: Promise<void>[] = []
    activeSubscriptionAssetIds.forEach((assetId) => {
      staleSubscriptions.push(store.dispatch.assets.unsubscribeAsset(assetId))
    })
    await Promise.all(staleSubscriptions)
    activeSubscriptionAssetIds.clear()
  })

  const castAssetDocs = computed(() => {
    const pick = pickBy(store.state.assets.subscribedAssets, (_asset, assetId) => castAssetIds.value.has(assetId))
    return pick
  })

  return {
    castAssetDocs
  }
}

export default useCastScenesAssets
